import { computed as r, defineAsyncComponent as a, openBlock as d, createBlock as p, resolveDynamicComponent as f, normalizeProps as u, guardReactiveProps as s, withCtx as m, renderSlot as c } from "vue";
import { themeProp as y } from "../../composables/useTheme.js";
import { screenProp as v } from "../../utils/utilsScreen.js";
import g from "../../utils/validators/orientation.js";
import B from "../../utils/validators/image.js";
import h from "../../utils/validators/video.js";
import b from "../../utils/validators/link.js";
const C = /* @__PURE__ */ Object.assign({
  name: "DsMediaTextBlock"
}, {
  __name: "media-text-block",
  props: {
    ...y,
    ...v,
    contained: {
      type: Boolean,
      default: !1
    },
    orientation: {
      type: String,
      default: "right",
      validator: (e) => g(e)
    },
    fullWidthContent: {
      type: Boolean,
      default: !1
    },
    fullWidthMedia: {
      type: Boolean,
      default: !1
    },
    fullHeightMedia: {
      type: Boolean,
      default: !1
    },
    centerAligned: {
      type: Boolean,
      default: !1
    },
    /**
     * Image, optional
     * @property {Object} image.small - { src: String, name: String }
     * @property {Object} image.medium - { src: String, name: String }
     * @property {Object} image.large - { src: String, name: String }
     */
    image: {
      type: Object,
      default: null,
      validator: (e) => B(e)
    },
    aspectRatio: {
      type: String,
      default: null
    },
    /**
     * Video, optional
     * @property {String} title
     * @property {Object} thumbnail - { small: { src: String, name: String }, medium, large }
     * @property {Object} sizes - { small: { width: Number, height: Number }, medium, large }
     * @property {String} extension
     * @property {Boolean} selfHosted
     * @property {String} src
     */
    video: {
      type: Object,
      default: null,
      validator: (e) => h(e)
    },
    videoAutoplay: {
      type: Boolean,
      default: !1
    },
    eyebrow: {
      type: String,
      default: ""
    },
    icon: {
      type: Object,
      default: null,
      validator: (e) => ["name", "category"].every((t) => t in e)
    },
    title: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    /**
     * Link
     * @property {string} link.title - link title
     * @property {string} link.url - link href value
     * @property {boolean} link.openInNewWindow - open the link in a new window
     * @property {boolean} link.nuxt - renders as nuxt link
     */
    link: {
      type: Object,
      default: null,
      validator: (e) => b(e)
    },
    withShadow: {
      type: Boolean,
      default: !1
    },
    eyebrowAsTag: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, l = r(() => t.contained ? i : n), n = a(() => import("./components/media-text-component.vue.js")), i = a(
      () => import("./components/media-text-contained-component.vue.js")
    );
    return (o, S) => (d(), p(f(l.value), u(s(o.$props)), {
      default: m(() => [
        c(o.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), A = C;
export {
  A as default
};
